export default {
  termeni_si_conditii: 'Terms and conditions',
  pagina_termeni_si_conditii: 'terms-and-conditions'
}
